import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/fila-atendimento`

    return {
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list() {

            return repository.get(`${baseUrl}/list`)
        },
    }
}